import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { forEach, isEmpty } from 'lodash-es';
import { SITE_URL } from 'client/site-modules/shared/pages/seo';

const FORM_PARAMS_MAPPING = {
  'payment-feedback': {
    Field138: 'paymentType',
    Field115: 'price',
    Field118: 'netCapCost',
    Field132: 'monthly',
    Field125: 'taxesAndFeesZipCode',
    Field130: 'creditTier',
    Field136: 'apr',
    Field123: 'downPayment',
    Field120: 'tradeIn',
    Field119: 'totalTaxesAndFees',
    Field121: 'numberOfMonths',
    Field122: 'annualMileage',
    Field134: 'priceTooltipText',
  },
  'see-something-wrong-with-this-rebate': {
    Field107: 'make',
    Field103: 'model',
    Field106: 'sessionId',
    Field105: 'incentiveId',
  },
};

const getParams = (link, data, mapping) => {
  if (isEmpty(mapping)) {
    return link;
  }

  const params = [];
  forEach(mapping, (value, paramName) => {
    const paramValue = data[value];
    if (paramValue) {
      params.push(`&${paramName}=${encodeURIComponent(paramValue)}`);
    }
  });
  return `${link}${params.join('')}`;
};

export function ReportSmthWrongLinkUI({
  title = '',
  paramsData = {},
  form = 'see-something-wrong',
  iconClassName = '',
  linkClassName = '',
  trackingId = '',
  trackingValue = '',
  location = {
    pathname: '',
    search: '',
  },
}) {
  const { pathname, search } = location;
  const pageHref = SITE_URL + pathname + search;
  const mapping = FORM_PARAMS_MAPPING[form];
  const link = `https://tier3.wufoo.com/forms/${form}/?Field7=${encodeURIComponent(pageHref)}`;

  return (
    <a
      href={getParams(link, paramsData, mapping)}
      className={linkClassName}
      data-tracking-id={trackingId}
      data-tracking-value={trackingValue}
      data-tracking-disabled={!trackingId}
      target="_blank"
      rel="noopener noreferrer"
    >
      {iconClassName && <span className={iconClassName} aria-hidden />}
      {title}
    </a>
  );
}

ReportSmthWrongLinkUI.propTypes = {
  trackingId: PropTypes.string,
  trackingValue: PropTypes.string,
  title: PropTypes.string,
  linkClassName: PropTypes.string,
  iconClassName: PropTypes.string,
  trackingData: PropTypes.shape({}),
  location: PropTypes.shape({
    pathname: PropTypes.string,
    search: PropTypes.string,
  }),
  paramsData: PropTypes.shape({
    paymentType: PropTypes.string,
    price: PropTypes.number,
    netCapCost: PropTypes.number,
    monthly: PropTypes.number,
    taxesAndFeesZipCode: PropTypes.string,
    creditTier: PropTypes.string,
    apr: PropTypes.number,
    tradeIn: PropTypes.number,
    totalTaxesAndFees: PropTypes.number,
    term: PropTypes.number,
    annualMileage: PropTypes.number,
    priceTooltipText: PropTypes.string,
    make: PropTypes.string,
    model: PropTypes.string,
    incentiveId: PropTypes.string,
    sessionId: PropTypes.string,
  }),
  form: PropTypes.string,
};

export const ReportSmthWrongLink = withRouter(ReportSmthWrongLinkUI);
